import { Stack, HStack, Text, Button, useDisclosure } from "@chakra-ui/react";
import { CurrencyText } from "../../../shared/ui";
import { Repeat } from "../../../shared/icons";
import { formatarMesAno } from "../../../shared/lib/date";
import { useShiftPatternPreviewQuery } from "../hooks/shiftPatternQueries";
import GenerateScheduleModal from "./GenerateScheduleModal";

// Lembrete do Dashboard: enquanto houver plantão da escala fixa do mês corrente ainda não
// registrado nem pulado, convida o médico a conferir e gerar. Some sozinho quando a
// escala foi conferida (ou quando não há escala fixa cadastrada).
export default function ScheduleReadyCard({ today = new Date() }) {
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const disclosure = useDisclosure();
  const { data } = useShiftPatternPreviewQuery({ year, month });
  const pending = (data?.items ?? []).filter((item) => !item.already_registered && !item.skipped);
  const total = pending.reduce((acc, item) => acc + item.valor, 0);

  // O modal fica fora do condicional: gerar a escala zera `pending` com ele ainda aberto.
  return (
    <>
      {pending.length > 0 ? (
        <Stack
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align={{ base: "stretch", md: "center" }}
          spacing={3}
          p={4}
          mb={6}
          borderRadius="xl"
          bg="accent-subtle"
          border="1px solid"
          borderColor="accent-subtle-border"
        >
          <HStack spacing={3} align="flex-start" color="accent-text-strong">
            <Repeat size={18} />
            <Text fontSize="sm">
              <Text as="span" fontWeight="semibold">
                Sua escala fixa de {formatarMesAno(year, month)} está pronta:
              </Text>{" "}
              {pending.length} plantão(ões) para conferir · <CurrencyText value={total} />
            </Text>
          </HStack>
          <Button size="sm" leftIcon={<Repeat size={14} />} onClick={disclosure.onOpen} flexShrink={0}>
            Conferir e gerar
          </Button>
        </Stack>
      ) : null}
      <GenerateScheduleModal isOpen={disclosure.isOpen} onClose={disclosure.onClose} initialYear={year} initialMonth={month} />
    </>
  );
}
